import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const MOCK_WEATHER = {
  temp: '18',
  condition: 'Partly Cloudy',
  wind: '12 km/h NW',
  humidity: '52%',
  forecast: 'Clear evening, chance of rain Friday',
  sprayConditions: 'Good - wind under 15 km/h',
};

const MOCK_OPS = [
  { id: 'OP-2025-061', type: 'Canola Seeding', field: 'North Range', acres: 320, completed: 280, status: 'active', equipment: 'NH T9.645 #1 + Bourgault 3420', operator: 'Travis Makuch', startTime: '5:30 AM' },
  { id: 'OP-2025-062', type: 'Field Spraying', field: 'East Block', acres: 160, completed: 95, status: 'active', equipment: 'NH SP.400F Sprayer', operator: 'Dylan Favel', startTime: '7:00 AM' },
  { id: 'OP-2025-063', type: 'Fertilizer Application', field: 'Kamsack Main', acres: 480, completed: 480, status: 'completed', equipment: 'NH T8.435 + Bourgault 7950', operator: 'Brett Olson', startTime: '4:00 AM' },
  { id: 'OP-2025-064', type: 'Harrowing', field: 'West Quarter', acres: 200, completed: 120, status: 'active', equipment: 'NH T7.315 + 60ft Harrows', operator: 'Cody Fiddler', startTime: '6:00 AM' },
  { id: 'OP-2025-065', type: 'Grain Cart', field: 'South Field', acres: 280, completed: 0, status: 'scheduled', equipment: 'NH T6.180 + Brent Cart', operator: 'Jake Fehr', startTime: '2:00 PM' },
];

const MOCK_EQUIPMENT = [
  { name: 'NH T9.645 SmartTrax #1', status: 'running', field: 'North Range', operator: 'Travis Makuch' },
  { name: 'NH T9.645 SmartTrax #2', status: 'running', field: 'Kamsack Main', operator: 'Kyle Fehr' },
  { name: 'NH CR10.90 Combine #1', status: 'idle', field: 'Storage', operator: 'Unassigned' },
  { name: 'NH SP.400F Sprayer', status: 'running', field: 'East Block', operator: 'Dylan Favel' },
  { name: 'NH T8.435', status: 'running', field: 'Kamsack Main', operator: 'Brett Olson' },
  { name: 'Bourgault 3420-100 PHD', status: 'running', field: 'North Range', operator: 'Travis Makuch' },
];

const MOCK_SHIFTS = [
  { shift: 'Day Shift (5AM - 5PM)', crew: 8, status: 'active', lead: 'Kyle Fehr' },
  { shift: 'Evening Shift (5PM - 12AM)', crew: 3, status: 'upcoming', lead: 'Trevor Favel' },
  { shift: 'Off Rotation', crew: 1, status: 'off', lead: 'N/A' },
];

function DashboardPage() {
  const [weather] = useState(MOCK_WEATHER);
  const [ops] = useState(MOCK_OPS);
  const [shifts] = useState(MOCK_SHIFTS);
  const [equipment] = useState(MOCK_EQUIPMENT);
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  useEffect(() => {
    // Future: fetch from Supabase
  }, []);

  const getStatusBadge = (status) => {
    const map = { active: 'badge-success', completed: 'badge-default', scheduled: 'badge-warning', paused: 'badge-warning', upcoming: 'badge-warning', off: 'badge-default', running: 'badge-success', idle: 'badge-warning' };
    return map[status] || 'badge-default';
  };

  const totalAcres = ops.reduce((s, o) => s + o.acres, 0);
  const completedAcres = ops.reduce((s, o) => s + o.completed, 0);
  const activeOps = ops.filter(o => o.status === 'active').length;
  const runningEquip = equipment.filter(e => e.status === 'running').length;

  const thStyle = { padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 };
  const tdStyle = { padding: '10px 12px', fontSize: '0.85rem' };

  return (
    <div className="page-body">
      <div className="page-header">
        <div>
          <h1 style={{ margin: 0 }}>Dashboard</h1>
          <p style={{ margin: '4px 0 0', opacity: 0.7, fontSize: '0.85rem' }}>Geerts Farms Ltd. &mdash; {today}</p>
        </div>
      </div>

      {/* Summary KPIs */}
      <div className="stats-grid">
        <div className="stat-card">
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Active Operations</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--primary)' }}>{activeOps}</div>
        </div>
        <div className="stat-card">
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Acres Planned</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--primary)' }}>{totalAcres.toLocaleString()}</div>
        </div>
        <div className="stat-card">
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Acres Completed</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--primary)' }}>{completedAcres.toLocaleString()}</div>
        </div>
        <div className="stat-card">
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 }}>Equipment Running</div>
          <div style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--primary)' }}>{runningEquip}/{equipment.length}</div>
        </div>
      </div>

      {/* Weather Card */}
      <div className="card" style={{ marginTop: "16px" }}>
        <h3 style={{ margin: '0 0 12px' }}>Weather &mdash; Kamsack, SK</h3>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "16px" }}>
          <div>
            <div style={{ fontSize: '0.75rem', opacity: 0.6 }}>Temperature</div>
            <div style={{ fontSize: "1.2rem", fontWeight: 600 }}>{weather.temp}&deg;C</div>
          </div>
          <div>
            <div style={{ fontSize: '0.75rem', opacity: 0.6 }}>Condition</div>
            <div style={{ fontSize: "1.2rem", fontWeight: 600 }}>{weather.condition}</div>
          </div>
          <div>
            <div style={{ fontSize: '0.75rem', opacity: 0.6 }}>Wind</div>
            <div style={{ fontSize: "1.2rem", fontWeight: 600 }}>{weather.wind}</div>
          </div>
          <div>
            <div style={{ fontSize: '0.75rem', opacity: 0.6 }}>Humidity</div>
            <div style={{ fontSize: "1.2rem", fontWeight: 600 }}>{weather.humidity}</div>
          </div>
          <div>
            <div style={{ fontSize: '0.75rem', opacity: 0.6 }}>Spray Conditions</div>
            <div style={{ fontSize: "1.2rem", fontWeight: 600, color: "var(--primary)" }}>{weather.sprayConditions}</div>
          </div>
          <div>
            <div style={{ fontSize: '0.75rem', opacity: 0.6 }}>Forecast</div>
            <div style={{ fontSize: "1.2rem", fontWeight: 600 }}>{weather.forecast}</div>
          </div>
        </div>
      </div>

      {/* Active Operations Table */}
      <div className="card" style={{ marginTop: "16px" }}>
        <h3 style={{ margin: '0 0 12px' }}>Today's Operations</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)", textAlign: "left" }}>
                <th style={thStyle}>Op ID</th>
                <th style={thStyle}>Type</th>
                <th style={thStyle}>Field</th>
                <th style={thStyle}>Progress</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Equipment</th>
                <th style={thStyle}>Operator</th>
                <th style={thStyle}>Start</th>
              </tr>
            </thead>
            <tbody>
              {ops.map((op) => (
                <tr key={op.id} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                  <td style={{ ...tdStyle, fontFamily: 'monospace' }}>{op.id}</td>
                  <td style={{ ...tdStyle, fontWeight: 600 }}>{op.type}</td>
                  <td style={tdStyle}>{op.field}</td>
                  <td style={tdStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ width: "80px", height: "6px", background: "rgba(255,255,255,0.1)", borderRadius: "3px" }}>
                        <div style={{ width: Math.round((op.completed / op.acres) * 100) + "%", height: "100%", borderRadius: "3px", background: "var(--primary)" }} />
                      </div>
                      <span style={{ fontSize: '0.8rem' }}>{op.completed}/{op.acres} ac</span>
                    </div>
                  </td>
                  <td style={tdStyle}><span className={getStatusBadge(op.status)}>{op.status}</span></td>
                  <td style={tdStyle}>{op.equipment}</td>
                  <td style={tdStyle}>{op.operator}</td>
                  <td style={tdStyle}>{op.startTime}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Equipment Quick Status */}
      <div className="card" style={{ marginTop: "16px" }}>
        <h3 style={{ margin: '0 0 12px' }}>Equipment Status</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px' }}>
          {equipment.map((eq) => (
            <div key={eq.name} style={{ background: 'var(--bg)', borderRadius: '8px', padding: '12px', borderLeft: eq.status === 'running' ? '4px solid var(--primary)' : '4px solid var(--border)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 600, fontSize: '0.9rem' }}>{eq.name}</span>
                <span className={getStatusBadge(eq.status)} style={{ textTransform: 'capitalize' }}>{eq.status}</span>
              </div>
              <div style={{ fontSize: '0.8rem', opacity: 0.6, marginTop: '4px' }}>{eq.field} &bull; {eq.operator}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Crew Shifts */}
      <div className="card" style={{ marginTop: "16px" }}>
        <h3 style={{ margin: '0 0 12px' }}>Crew Shifts</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)", textAlign: "left" }}>
                <th style={thStyle}>Shift</th>
                <th style={thStyle}>Crew Size</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Shift Lead</th>
              </tr>
            </thead>
            <tbody>
              {shifts.map((s, idx) => (
                <tr key={idx} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                  <td style={{ ...tdStyle, fontWeight: 600 }}>{s.shift}</td>
                  <td style={tdStyle}>{s.crew} members</td>
                  <td style={tdStyle}><span className={getStatusBadge(s.status)}>{s.status}</span></td>
                  <td style={tdStyle}>{s.lead}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
